import { render, staticRenderFns } from "./DifficultySelector.vue?vue&type=template&id=77797c34"
import script from "./DifficultySelector.vue?vue&type=script&lang=js"
export * from "./DifficultySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports